module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "CN",
    attrs: {
      "id": "pt2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062365606_Contents#rpt2"
    }
  }, [_vm._v("part two")])]), _vm._v(" "), _c('p', {
    staticClass: "Part-headings_PTO1_Part_title_2"
  }, [_c('span', {
    staticClass: "small"
  }, [_c('a', {
    attrs: {
      "href": "#/text/9780062365606_Contents#rpt2"
    }
  }, [_vm._v("FRANCE")])])]), _vm._v(" "), _c('p', {
    staticClass: "FME1_Frontmatter_epigraph_other_1 ParaOverride-7"
  }, [_vm._v("‘And at home by the fire, whenever you look up there I shall be – and whenever I look up there will be you.’")]), _vm._v(" "), _c('p', {
    staticClass: "FME1_Frontmatter_epigraph_other_1 ParaOverride-8"
  }, [_vm._v("Her countenance fell, and she was silent awhile.")]), _vm._v(" "), _c('p', {
    staticClass: "FME2_Frontmatter_epigraph_other_2 _idGenParaOverride-1"
  }, [_vm._v("Thomas Hardy, "), _c('i', [_vm._v("Far From the Madding Crowd")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e9048c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062365606_Part_2.vue
// module id = 81
// module chunks = 0